/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentSummaryDetail {
    getFixupPrototypeFunction() { return ComplianceAssessmentSummaryDetail.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentSummaryDetail>): ComplianceAssessmentSummaryDetail {
        let obj = Object.assign(new ComplianceAssessmentSummaryDetail(), model);
        ComplianceAssessmentSummaryDetail.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentSummaryDetail>): ComplianceAssessmentSummaryDetail {
        if (!model) return null;
        return ComplianceAssessmentSummaryDetail.newInstance(<ComplianceAssessmentSummaryDetail> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentSummaryDetail) {
        if (!obj) return;

        models.ComplianceAssessmentSummaryDetail.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentSummaryDetail): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentSummaryDetail.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.assessment_summary_details) {
            for (let val of this.assessment_summary_details) {
                models.ComplianceAssessmentSummaryAccountDetail.fixupPrototype(val);
            }
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * List of assessment summary details per service account
     */
    assessment_summary_details: Array<models.ComplianceAssessmentSummaryAccountDetail>;

}
